import axios from 'axios';
import config from 'config';
import { showSessionExpiredOverlay } from '../utils/sessionExpiredHandler';

// const prod = process.env.NODE_ENV === 'production'
export const service = axios.create({
  baseURL: config.apiUrl,
  withCredentials: true
  // timeout: 60000
});

service.interceptors.request.use((reqConfig) => {
  const token = localStorage.getItem('token');
  reqConfig.headers = {
    Accept: 'application/json',
    Authorization: token ? 'Bearer ' + token : ''
  };
  return reqConfig;
});

service.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      showSessionExpiredOverlay();
    }
    return Promise.reject(error);
  }
);

export const http_client = {
  get: (path, queryParams) => {
    return service.get(path, {
      params: queryParams
    });
  },
  getFile: (path, queryParams) => {
    return service.get(path, {
      params: queryParams,
      responseType: 'blob'
    });
  },
  post: (path, body, queryParams, setProgress = null) => {
    return service.post(path, body, {
      params: queryParams,
      onUploadProgress: (progressEvent) => {
        let progress = ((progressEvent?.loaded ?? 1) / (progressEvent?.total ?? 1)) * 100;
        if (setProgress != null) {
          setProgress(progress);
        } else {
          return progress;
        }
      }
    });
  },
  patch: (path, body) => {
    return service.patch(path, body);
  },
  delete: (path) => {
    return service.delete(path);
  }
};
